module.exports = __webpack_public_path__ + "media/Images/icon-share-e591d769aa7f1a8f4226a94400a569b3.svg";